export default {
	欢迎回来: '欢迎回来',
	设置密码: '设置密码',
}
